module.exports = __webpack_public_path__ + "img/service-icon2.763f53f0.png";